module.exports = __webpack_public_path__ + "img/soulition2.2179dd0a.png";